import { Column, ColumnConfig, IColumn } from "../base-column/column.model";
import { ColumnTypeEnum } from "../base-column/column-type-enum";
import { initFromConfig, initFromProps } from "../common-models/init-functions";


//Πρέπει να δημιουργηθεί Component το οποία θα επεκτείνει την Abstract BaseColumn και θα πρέπει να υλοποιεί το IColumn Interface
export class IconColumn<T> extends Column<T> implements IColumn<T>{

  constructor(config: ColumnConfig<T>);
  constructor(
    name?: string,
    propertyName?: string,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event? : any) => any
  );
  constructor(
    configOrName?: ColumnConfig<T> | string,
    propertyName?: string,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event? : any) => any,
  ) {
    super();
    if (typeof configOrName === 'object') {
      const config = configOrName as ColumnConfig<T>;
      initFromConfig(this, config);
    } else {
      initFromProps(this, configOrName, propertyName, undefined, tooltip, action);
    }
  }

  GetAction(row: T, event? : any) {
    if (this.Action) {
      if(event){
        return this.Action(row, event);
      }
      return this.Action(row);
    } else {
      console.log('Action is not defined in icon column.');
    }
  }

  GetTooltip(): string | ((item?: any) => string) {
    return this.Tooltip ?? null;
  }

  GetSort(): boolean {
    return false;
  }
  GetPropertyName(): string{
    return this.PropertyName ?? null;
  }
  GetName(): string {
    return this.Name ?? '';
  }
  //Θα επιστρέφει το αντίστοιχο entry από το Enum για DateColumn
  GetColumnType(): string {
    return ColumnTypeEnum.IconColumn;
  }

  //Θα πρέπει να επιστρέφει το value που θα εμφανιστεί στο grid βασισμένο στο Propertyname μετά από τους μετασχηματισμούς.
  //Για την υποστήριξη των nested object θα πρέπει να υπάρχει split και recursive αναζήτηση των properties.
  GetValue(): string | ((item?: any) => string){
    return this.Action ?? '';
  }
}
